import React from 'react';
import PropTypes from 'prop-types';
import { decodeHexToJSON, LedgerEntryType } from '../../common/Helpers';
import { getFlagTag, parseMPTokenIssuanceFlags } from '../../common/FlagHelpers';
import { FormattedNumber } from 'react-intl';
import ReactJson from 'react-json-view';
import XCopyButton from '../../lib/XCopyButton';

const MPTokenIssuance = (props) => {
    const { node } = props;

    if ( node?.LedgerEntryType === LedgerEntryType.MPTokenIssuance ) {
        return (
            <>
                {node?.mpt_issuance_id &&
                <tr>
                    <td>mpt_issuance_id:</td>
                    <td>
                        <span className="text-muted hash">
                            {node.mpt_issuance_id}
                            <XCopyButton text={node.mpt_issuance_id} />
                            <XCopyButton url={`/mpt/${node.mpt_issuance_id}`} />
                        </span>
                    </td>
                </tr>
                }
                {node?.Issuer &&
                <tr>
                    <td>Issuer:</td>
                    <td>{node.Issuer}</td>
                </tr>
                }
                {node?.OutstandingAmount >= 0 &&
                <tr>
                    <td>OutstandingAmount:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.OutstandingAmount}/>
                    </td>
                </tr>
                }
                {node?.MaximumAmount >= 0 &&
                <tr>
                    <td>MaximumAmount:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.MaximumAmount}/>
                    </td>
                </tr>
                }
                {node?.AssetScale >= 0 &&
                <tr>
                    <td>AssetScale:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.AssetScale}/>
                    </td>
                </tr>
                }
                {node?.TransferFee >= 0 &&
                <tr>
                    <td>TransferFee:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.TransferFee}/>
                    </td>
                </tr>
                }
                {node?.MPTokenMetadata &&
                <tr>
                    <td>MPTokenMetadata:</td>
                    <td>
                        <ReactJson
    		          		src={decodeHexToJSON(node.MPTokenMetadata)}
	    	          		collapseStringsAfterLength={64}
		              		enableClipboard={true}
		              		indentWidth={4}
                            iconStyle='square'
	          	    	/>
                    </td>
                </tr>
                }

                {node?.Flags > 0 &&
                <tr>
                    <td>Flags:</td>
                    <td>
                        {getFlagTag(node.Flags, parseMPTokenIssuanceFlags)}
                    </td>
                </tr>
                }
            </>
        );    
    } else {
        return <></>;
    }
}

MPTokenIssuance.propTypes = {
    node: PropTypes.object,
}

export default MPTokenIssuance;